import React from 'react';
import { PropTypes } from 'prop-types';
import formatDate from 'common/utils/Dates/formatDate';
import { useFeatureFlag } from 'common/hooks';
import EnrollmentStatusIndicator from '../EnrollmentStatusIndicator';
import AssignUserToEnrollment from '../AssignUserToEnrollment';
import MarkEnrollmentAsUrgentCheckbox from '../MarkEnrollmentAsUrgentCheckbox';
import { ENROLLMENT_STATUSES } from '../../constants';

const EnrollmentDetailsCardHeader = ({ enrollmentRequest, label }) => {
  const markAsUrgentEnabled = useFeatureFlag('pays-enrollment-mark-as-urgent');

  return (
    <div className="flex justify-between pb-4">
      <div>
        <h1 className="pt-2 text-2xl font-semibold text-text-blue leading-8">
          {label + enrollmentRequest.short_id}
        </h1>
        <div className="flex pb-2 space-x-6 items-center">
          <p className="text-text-blue text-sm leading-5">
            Last updated: {formatDate(enrollmentRequest.updated_at)}
          </p>
          <EnrollmentStatusIndicator status={enrollmentRequest.enrollment_status} />
          {markAsUrgentEnabled &&
            [ENROLLMENT_STATUSES.open, ENROLLMENT_STATUSES.inReview].includes(enrollmentRequest.enrollment_status) && (
              <MarkEnrollmentAsUrgentCheckbox
                enrollmentId={enrollmentRequest.id}
                isUrgent={enrollmentRequest.urgent}
              />
            )}
        </div>
      </div>
      <div>
        <AssignUserToEnrollment enrollmentRequest={enrollmentRequest} />
      </div>
    </div>
  );
};

EnrollmentDetailsCardHeader.propTypes = {
  enrollmentRequest: PropTypes.shape({
    id: PropTypes.string.isRequired,
    short_id: PropTypes.string.isRequired,
    updated_at: PropTypes.string.isRequired,
    enrollment_status: PropTypes.string.isRequired,
    status: PropTypes.string,
    urgent: PropTypes.bool,
    assignee: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  label: PropTypes.string.isRequired,
};

export default EnrollmentDetailsCardHeader;
